module.exports = __webpack_public_path__ + "../assets/img/84d7917ad8f1bc0775d1a32d4bf93be9.svg";